export default __webpack_public_path__ + "static/media/sidebar-close.b4d34048.svg";